/** Максимум одновременно видимых toast. */
export const MAX_NOTIFICATION_COUNT = 5;

/** Минимальный интервал между добавлениями (мс). */
export const MIN_MS_BETWEEN_NOTIFICATIONS = 200;

/** Длительность toast по умолчанию (мс). */
export const DEFAULT_NOTIFICATION_DURATION_MS = 4500;
